export default __webpack_public_path__ + "static/media/OrangeCanvas.3c95fa76.webp";